// extracted by mini-css-extract-plugin
export var container = "_3q-0";
export var error = "_3q-9";
export var label = "_3q-5";
export var light = "_3q-6";
export var md = "_3q-3";
export var sm = "_3q-2";
export var thin = "_3q-8";
export var thinBold = "_3q-7";
export var vertical = "_3q-4";
export var xs = "_3q-1";